import React, { useContext, useMemo } from 'react';
import { AppContext } from '../../../../../../../contexts/AppContext';

function getSelectedProductSku(currentAttributeState, contentData) {
  const { skus } = contentData;

  const allAttributesSelected = Object.values(currentAttributeState).every(
    (attribute) => attribute.selectedValue !== undefined
  );

  if (!allAttributesSelected) {
    return null;
  }

  const matchingSku = skus.find((sku) =>
    sku?.definingAttributes?.every(({ name, value }) => {
      const selectedValue = currentAttributeState[name]?.selectedValue;
      return !selectedValue || selectedValue.toLowerCase() === value.value.toLowerCase();
    })
  );

  return matchingSku ? matchingSku.partnumber : null;
}

export default function useSelectedProductSku(currentAttributeState) {
  const { state } = useContext(AppContext);
  const { contentData } = state;

  return useMemo(() => {
    return getSelectedProductSku(currentAttributeState, contentData);
  }, [currentAttributeState, contentData]);
}
